// @ts-nocheck
// Boarding Pass PDF generator — extracted VERBATIM from CharterAgreementPage.handleDownloadBoardingPass.
// Same PDF, same dynamic fields, same vesselCapacity map, same logo/fallback.
// Only adaptation: component-scope `bookingData` → function param; previewOnly → opts.previewOnly;
// the original `t.ca_alertNoBookingExcl` alert string (component i18n scope) → neutral message.

export function generateBoardingPass(bookingData, opts = {}) {
  const previewOnly = !!opts.previewOnly;
  const bookingCode = bookingData?.bookingCode || '';

  if (!bookingData) {
    alert('No booking data available.');
    return;
  }

  // Vessel capacity mapping
  const vesselCapacity: { [key: string]: number } = {
    'Lagoon 42-BOB': 12,
    'Lagoon 46-PERLA': 12,
    'Bali 4.2-INFINITY': 10,
    'Bavaria C42-CRUISER-KALISPERA': 8,
    'Bavaria C42-CRUISER-VALESIA': 8,
    'Beneteau Oceanis 46': 10,
    'Jeanneau 54': 12,
    'Jeanneau 449': 10
  };

  // Get max people for this vessel
  const shortCapacity = { 'bob': 12, 'perla': 12, 'infinity': 10, 'kalispera': 8, 'valesia': 8, 'maria 1': 10, 'maria 2': 12, 'bar bar': 10 };
  const vName = (bookingData.vesselName || (bookingData._sync && bookingData._sync.vesselName) || '').toString().trim().toLowerCase();
  let maxPeople = vesselCapacity[bookingData.vesselName] || '';
  if (!maxPeople && vName) {
    for (const k in shortCapacity) {
      if (vName === k || vName.indexOf(k) !== -1 || k.indexOf(vName) !== -1) { maxPeople = shortCapacity[k]; break; }
    }
  }

  const { jsPDF } = window.jspdf;
  const doc = new jsPDF();

  // Load logo from Google Drive
  const logoImg = new Image();
  logoImg.crossOrigin = 'anonymous';
  logoImg.src = 'https://drive.google.com/uc?export=download&id=1DOmo-MO9ZsfmZm7ac4olSF8nl3dJAAer';

  let logoLoaded = false;

  logoImg.onload = () => {
    logoLoaded = true;
    generatePDF(true);
  };

  logoImg.onerror = () => {
    console.warn('Logo failed to load, using text fallback');
    generatePDF(false);
  };

  setTimeout(() => {
    if (!logoLoaded) {
      console.warn('Logo timeout, using text fallback');
      generatePDF(false);
    }
  }, 2000);

  const generatePDF = (hasLogo: boolean) => {
    try {
      if (hasLogo) {
        // Add logo
        doc.addImage(logoImg, 'PNG', 20, 10, 40, 18);
      } else {
        // Fallback to text
        doc.setFontSize(18);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(255, 165, 0);
        doc.text('TAILWIND', 20, 20);
      }
    } catch (e) {
      console.error('Error adding logo:', e);
      // Fallback to text
      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(255, 165, 0);
      doc.text('TAILWIND', 20, 20);
    }

    // BOARDING PASS title at top right
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(24);
    doc.setFont('helvetica', 'bold');
    doc.text('BOARDING PASS', 190, 20, { align: 'right' });

    // ===== LEFT COLUMN =====
    let leftY = 45;

    // BOOKING DETAILS
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text('BOOKING DETAILS:', 20, leftY);

    leftY += 7;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text('Booking No:', 20, leftY);
    doc.text(bookingData.bookingCode || '', 50, leftY);

    leftY += 5;
    doc.text('Client:', 20, leftY);
    doc.text(bookingData.clientName || '', 50, leftY);

    leftY += 5;
    doc.text('Agency:', 20, leftY);
    doc.text(bookingData.agency || '', 50, leftY);

    leftY += 8;
    doc.text('Boat Type/Name:', 20, leftY);
    doc.text(bookingData.vesselName || '', 60, leftY);

    leftY += 5;
    doc.text(`Check-in: ${bookingData.checkInDate || ''} (17:00h) - Athens / Alimos Marina`, 20, leftY);

    leftY += 5;
    doc.text(`Check-out: ${bookingData.checkOutDate || ''} (09:00h) Athens / Alimos Marina`, 20, leftY);

    leftY += 8;
    doc.text(`Max people onboard (including any crew): ${maxPeople}`, 20, leftY);

    leftY += 6;
    doc.text('Return to base: One day before check-out date', 20, leftY);
    leftY += 5;
    doc.text('the latest 17:00.', 20, leftY);

    leftY += 6;
    doc.text('Fuel: is paid by the charterer upon return of the boat.', 20, leftY);

    // LATE CHECK-IN (removed CREW LIST FORM section)
    leftY += 12;
    doc.setFont('helvetica', 'bold');
    doc.text('LATE CHECK-IN (only for bareboat charters):', 20, leftY);

    leftY += 7;
    doc.setFont('helvetica', 'normal');
    doc.text('If the arrival of the skipper is after 21:00 a.m on', 20, leftY);
    leftY += 5;
    doc.text('embarkation day or Sunday there will be an extra', 20, leftY);
    leftY += 5;
    doc.text('charge of 200,00 EUR payable in cash on the spot.', 20, leftY);
    leftY += 5;
    doc.text('Please advise the skipper accordingly!', 20, leftY);

    // ===== RIGHT COLUMN =====
    let rightY = 45;

    // CONTACT INFORMATION
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.text('CONTACT INFORMATION:', 110, rightY);

    rightY += 7;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text('Contact person: Ms Maria Mazaraki', 110, rightY);

    rightY += 5;
    doc.text('Contact number: +30 6978196009 (WhatsApp & Viber)', 110, rightY);

    rightY += 5;
    doc.setTextColor(0, 0, 255);
    doc.textWithLink('Meeting location: Marina Alimos – Charter Village Box A47', 110, rightY, {
      url: 'https://www.google.gr/maps/place/Tailwind+Yachting/@37.913372,23.7079297,147m/'
    });
    doc.setTextColor(0, 0, 0);

    rightY += 5;
    doc.text('Company: Tailwind Yachting', 110, rightY);

    rightY += 5;
    doc.setTextColor(0, 0, 255);
    doc.text('E-mail: info@tailwindyachting.com', 110, rightY);
    doc.setTextColor(0, 0, 0);

    // REQUIRED FOR BOARDING
    rightY += 10;
    doc.setFont('helvetica', 'bold');
    doc.text('REQUIRED FOR BOARDING:', 110, rightY);

    rightY += 7;
    doc.setFont('helvetica', 'normal');
    doc.text('1. The boarding pass', 110, rightY);
    rightY += 6;
    doc.text('2. Passport / ID', 110, rightY);
    rightY += 6;
    doc.text("3. Skipper's license", 110, rightY);
    rightY += 6;
    doc.text('4. A card or cash for refundable security deposit.', 110, rightY);
    rightY += 6;
    doc.text('5. The total amount for extras as described above in cash.', 110, rightY);

    // e-PROVISIONING SERVICE
    rightY += 12;
    doc.setFont('helvetica', 'bold');
    doc.text('e-PROVISIONING SERVICE:', 110, rightY);

    rightY += 7;
    doc.setFont('helvetica', 'normal');
    doc.text('We suggest to pre-order your provisions upfront', 110, rightY);
    rightY += 5;
    doc.text('& online by ', 110, rightY);
    doc.setTextColor(0, 0, 255);
    doc.textWithLink('clicking here', 133, rightY, { url: 'https://store.yachtness.com/?tracking=tailwind' });
    doc.setTextColor(0, 0, 0);
    doc.text(" so you won't lose", 160, rightY);
    rightY += 5;
    doc.text('any valuable time on embarkation day.', 110, rightY);
    rightY += 6;
    doc.text('Our boats are based in Alimos marina, Pier 1.', 110, rightY);
    rightY += 5;
    doc.text('Please use these details for your delivery.', 110, rightY);
    rightY += 5;
    doc.text('You can pay online or on spot after the', 110, rightY);
    rightY += 5;
    doc.text('delivery of provisions.', 110, rightY);

    // TRANSFER SERVICE
    rightY += 12;
    doc.setFont('helvetica', 'bold');
    doc.text('TRANSFER SERVICE:', 110, rightY);

    rightY += 7;
    doc.setFont('helvetica', 'normal');
    doc.text('To ensure a smooth and timely transfer, we', 110, rightY);
    rightY += 5;
    doc.text('kindly ask that you pre-book your service ', 110, rightY);
    doc.setTextColor(0, 0, 255);
    doc.text('at least', 180, rightY);
    rightY += 5;
    doc.text('2 weeks', 110, rightY);
    doc.setTextColor(0, 0, 0);
    doc.text(' before embarkation. Payment will be', 126, rightY);
    rightY += 5;
    doc.text('made directly to the driver upon pickup.', 110, rightY);

    // Save PDF
    if (previewOnly) {
      const pdfUrl = doc.output('bloburl');
      window.open(pdfUrl, '_blank');
    } else {
      doc.save(`Boarding-Pass-${bookingCode}.pdf`);
    }
  };
}
